// BA_TYPEWON (Soort woning) — single source for the option list (WoningSpecificaties), the summary
// label (ApplicantSummary) and the Woonhuis Infofolio mapper. [AFD code, i18n key suffix under
// screens.woonhuis.options.houseType]. 'A' (Appartement/flat) and '6' (Maisonnette) are inboedel-only:
// R515 Inboedel_2024 accepts them, Woonhuis_2024 hard-declines them ("Het label BA_TYPEWON is niet
// acceptabel", XG 11).

export type HouseTypeVariant = 'woonhuis' | 'inboedel';

export const HOUSE_TYPE_OPTIONS: ReadonlyArray<readonly [code: string, i18nKey: string]> = [
  ['1', 'singleFamily'], ['2', 'detached'], ['3', 'seniorHouse'], ['4', 'townhouse'], ['6', 'maisonette'],
  ['10', 'linked'], ['12', 'kangaroo'], ['16', 'tinyHouse'], ['17', 'containerHouse'], ['A', 'apartment'],
  ['D', 'canalHouse'], ['G', 'garage'], ['H', 'corner'], ['L', 'bungalow'], ['R', 'recreationalHome'],
  ['T', 'semiDetached'], ['U', 'terraced'], ['V', 'farmhouse'], ['X', 'villa'], ['Y', 'chalet'],
];

export const INBOEDEL_ONLY_HOUSE_TYPES: readonly string[] = ['A', '6'];

// A Map, not an object: a plain object would answer prototype keys ('constructor', '__proto__').
const HOUSE_TYPE_KEY_BY_CODE = new Map<string, string>(HOUSE_TYPE_OPTIONS);

/** Option pairs per product: Inboedel gets the full list, Woonhuis without the inboedel-only codes. */
export const houseTypeOptionsFor = (variant: HouseTypeVariant): Array<[string, string]> =>
  HOUSE_TYPE_OPTIONS
    .filter(([code]) => variant === 'inboedel' || !INBOEDEL_ONLY_HOUSE_TYPES.includes(code))
    .map(([code, key]) => [code, key]);

/** i18n key suffix for a stored code; undefined for a code we do not know. */
export const houseTypeI18nKey = (code: string | number | null | undefined): string | undefined =>
  code == null || code === '' ? undefined : HOUSE_TYPE_KEY_BY_CODE.get(String(code));
